import { Input, Space, Dropdown } from "antd";
import { IoSearch } from "react-icons/io5";
import { LuSettings2 } from "react-icons/lu";
import { useTranslation } from "react-i18next";

const { Search } = Input;

const SearchBar = ({ onSearch }) => {
  const { t } = useTranslation();

  const items = [
    {
      key: "1",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.antgroup.com"
        >
          {t("menuItem1")}
        </a>
      ),
    },
    {
      key: "4",
      danger: true,
      label: t("dangerItem"),
    },
  ];

  const suffix = (
    <Dropdown trigger={["click"]} menu={{ items }} placement="bottomRight">
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          <LuSettings2 size={20} />
        </Space>
      </a>
    </Dropdown>
  );

  return (
    <Search
      placeholder={t("searchPlaceholder")}
      enterButton={<IoSearch />}
      size="large"
      suffix={suffix}
      onSearch={onSearch}
      className="search_bar"
    />
  );
};

export default SearchBar;
